import { useEffect } from 'react'
import ReactPixel from 'react-facebook-pixel'

//hooks
import useAutoScrollTop from '../../hooks/useAutoScrollTop'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { useSubscriptions } from '../../services/subscriptions.service'
import { useLocation } from 'react-router-dom'

//redux
import { store } from '../../store'
import { Creators as SubscriptionCreators } from '../../store/ducks/subscription'
import { Creators as LocaleCreators } from '../../store/ducks/locale'

import { getTimeZone } from '../../utils/timeZone'

//i18n
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import pt from '../../../_in18/pt-br.json'
// import en from '../../../_in18/en.json'

const DETECTION_OPTIONS = {
	order: ['navigator']
};

const options = {
	autoConfig: true,
	debug: false
}

interface IProps {
	children: any
}

i18n
	.use(LanguageDetector)
	.use(initReactI18next).init({
		detection: DETECTION_OPTIONS,
		resources: {
			// en,
			pt
		},
		//lng: language,
		fallbackLng: 'pt'
	})

function AppWrapper({ children, ...rest }: IProps) {
	useAutoScrollTop()

	const { data: dataSubscriptions } = useSubscriptions()

	function storeSubscriptions() {

		if (!dataSubscriptions?.data) return

		const allSubs = dataSubscriptions
			?.data
			?.filter(x => x.name.toLowerCase().indexOf('empresas') === -1)
			?.map(planSelected => {
			return {
				durationDays: (planSelected?.interval_count ?? 0) * 30,
				price_BRL: (planSelected?.name.match(/R\$ (\d+,\d+)/) ?? '')[0] ?? '',
				price_USD: '',
				mrc_product: planSelected?.mrc_product ?? '',
				vindi_plan_id: planSelected?.plan_id ?? 0,
				vindi_plan_description: planSelected?.name ?? '',
				vindi_plan_interval_name: planSelected?.interval_name ?? '',
				vindi_plan_installments: planSelected?.installments ?? 0
			}
		})

		store.dispatch(
			SubscriptionCreators.setAllExistingActiveSubscriptions(allSubs)
		)

		//TODO: it depends on user location
		store.dispatch(LocaleCreators.setCountry('Brazil'))
	}

	useEffect(storeSubscriptions, [dataSubscriptions])

	return children
}

export { AppWrapper }
